var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 101,
    viewBox: "0 0 106 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 105.12,
    height: 101,
    rx: 20,
    fill: "#A1CC3A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.1861 62.3787L67.9049 44.6599M37.5299 59.8474L61.9986 35.3787M52.458 20L76.858 27.32C76.858 27.32 84.2282 51.2325 76.858 63.1067C67.098 78.8311 52.458 81 52.458 81C52.458 81 37.0046 78.8311 28.058 63.1067C21.1468 50.9596 28.058 27.32 28.058 27.32L52.458 20Z",
    stroke: "#A1CC3A",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustSecure);
export default __webpack_public_path__ + "static/media/illust-secure.75a3f18ed275e03af3d33541769431f0.svg";
export { ForwardRef as ReactComponent };